import { Link, Typography, TypographyProps } from '@healthinal/ui';
import { forwardRef } from 'react';
import { theme } from '../theme.ts';

interface TypographyLinkProps extends TypographyProps {
  href: string;
  target?: string;
}
export const TypographyLink = forwardRef<HTMLAnchorElement, TypographyLinkProps>(
  ({ href, target, children, ...props }, ref) => (
    <Typography
      component={Link}
      sx={{ color: theme.vars.palette.focusVisible, textDecorationColor: theme.vars.palette.focusVisible }}
      href={href}
      target={target}
      ref={ref}
      {...props}>
      {children}
    </Typography>
  ),
);

TypographyLink.displayName = 'TypographyLink';
